module.exports = __webpack_public_path__ + "static/img/wap.36c735ca.jpg";